import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { ProgramaFormacao } from '../models/programa-formacao.model';


@Injectable({
  providedIn: 'root'
})
export class ProgramaFormacaoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all programas de formacao
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: ProgramaFormacao[] }>(`${this.path}/getAllProgramaFormacao`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      // debounceTime(500),
      map(response => response)
    );
  }

  // Get programa de formacao by ID
  public show(id: string): Observable<ProgramaFormacao> {
    return this.apiService.get<{ data: ProgramaFormacao, retorno: any }>(`${this.path}/getProgramaFormacaoById/${id}`).pipe(
      map(response => response.data as ProgramaFormacao)
    );
  }

  // Create new programa de formacao
  public store(programaFormacao: ProgramaFormacao): Observable<ProgramaFormacao> {
    console.log(programaFormacao)
    return this.apiService
      .post<{ object: ProgramaFormacao }>(`${this.path}/AddProgramaFormacao`, programaFormacao)
      .pipe(
        map((response) => response.object as ProgramaFormacao)
      );
  }

  // Update existing programa de formacao
  public update(programaFormacao: ProgramaFormacao, id: string): Observable<ProgramaFormacao> {
    return this.apiService
      .put<{ object: ProgramaFormacao }>(`${this.path}/UpdateProgramaFormacao`, programaFormacao)
      .pipe(
        map((response) => response.object as ProgramaFormacao)
      );
  }

  // Delete existing programa de formacao
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteProgramaFormacaoById/${id}`);
  }

  public toggleStatus(id: string): Observable<any> {
    return this.apiService.patch(`${this.path}/ToogleProgramaFormacaoStatus/${id}`, {});
  }
}
